// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/support.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { SupportService } from "./support_pb";

/**
 * @generated from rpc chalk.server.v1.SupportService.CreateCustomerIncident
 */
export const createCustomerIncident = SupportService.method.createCustomerIncident;
